import { IDiscordEmbed } from "#api/discord";
import { Markdown } from "./markdown";

import * as styles from "./styles.module.scss";

interface IProps {
  embed: IDiscordEmbed;
}

export function Embed({ embed }: IProps) {
  function calculateDimensions(width: number, height: number): object {
    const maxHeight = 300;
    const maxWidth = 400;
    if (width < maxWidth && height < maxHeight) {
      return {
        maxWidth: `${width}px`,
        maxHeight: `${height}px`,
        aspectRatio: `${width} / ${height}`,
      };
    }
    if (height > width) {
      // portrait
      let w = Math.round(width / height * maxHeight);
      return {
        maxWidth: `${w}px`,
        maxHeight: `${maxHeight}px`,
        aspectRatio: `${w} / ${maxHeight}`,
      };
    } else {
      let h = Math.round(height / width * maxWidth);
      return {
        maxWidth: `${maxWidth}px`,
        maxHeight: `${h}px`,
        aspectRatio: `${maxWidth} / ${h}`,
      };
    }
  }

  if (embed.provider?.name == "Tenor" && embed.video) {
    return <video src={embed.video.url} autoPlay loop />;
  }
  let color = embed.color ? `rgb(${(embed.color >> 16) & 255}, ${(embed.color >> 8) & 255}, ${embed.color & 255})` : "#3b3b41";
  return (
    <article className={styles.embed} style={{borderColor: color}}>
      <div>
        {embed.provider && (
          <section className={styles.header}>
            <a href={embed.provider.url}>{embed.provider.name}</a>
          </section>
        )}

        {embed.author && (
          <section className={styles.author}>
            {embed.author.url ? (
              <a href={embed.author.url}>
                <Markdown text={embed.author.name} />
              </a>
            ) : (
              <Markdown text={embed.author.name} />
            )}
          </section>
        )}

        {embed.title && (
          <section className={styles.title}>
            {embed.url ? (
              <a href={embed.url}>
                <Markdown text={embed.title} />
              </a>
            ) : (
              <Markdown text={embed.title} />
            )}
          </section>
        )}

        {embed.description && (
          <section className={styles.body}>
            <Markdown text={embed.description} />
          </section>
        )}

        {(embed.thumbnail || embed.video) && (
          <section className={styles.media}>
            {(embed.type == "video" && embed.video) ? (
              <video src={embed.video.url} controls style={calculateDimensions(embed.video.width ?? 1, embed.video.height ?? 1)} />
            ) : (embed.thumbnail) && (
              <a href={embed.thumbnail.url}>
                <img
                  src={embed.thumbnail.url}
                  alt={embed.title}
                  style={calculateDimensions(embed.thumbnail.width ?? 1, embed.thumbnail.height ?? 1)}
                  onError={e => (e.target as HTMLImageElement).style.height = "0"}
                />
              </a>
            )}
          </section>
        )}
      </div>
    </article>
  )
}
